import { FC } from 'react';

import { Errors } from '#/errors/errors';
import { OneError } from '#/errors/oneError';
import { useNavigation } from '#/hooks/useNavigation';
import { tb } from '#/store/translation/translation.store';

import { Status } from './Status';

interface NotFoundProps {
  /** Prevent the error from being sent to Sentry. */
  preventSentry?: boolean;
}

/**
 * Renders a Status component with a `CONFIGURATION_GENERAL_MISSING_PAGE` error.
 * This error is sent to Sentry by default.
 */
export const NotFound: FC<NotFoundProps> = ({ preventSentry = false }) => {
  const { goBack } = useNavigation('NotFound');

  return (
    <Status
      dismissMessage={tb('button.goBack')}
      error={
        new OneError(Errors.CONFIGURATION_GENERAL_MISSING_PAGE, {
          preventSentry,
        })
      }
      onDismiss={goBack}
    />
  );
};
